<template>
  <div id="app">
    <header-page v-if="isHiddenHeader === false"></header-page>
    <router-view/>
  </div>
</template>

<script>
import HeaderPage from './components/HeaderPage';

export default {
  name: 'App',
  components: {HeaderPage},
  mounted: function () {
    if (localStorage.getItem('lang') !== null) {
      this.$root.$i18n.locale = localStorage.getItem('lang')
    } else {
      localStorage.setItem('lang', 'it')
      this.$root.$i18n.locale = localStorage.getItem('lang')
    }

  },
  computed: {
    isHiddenHeader: function () {
      console.log(this.$route.name)
      if(this.$route.name === 'community')
        return true
      return false
    }
  }
}
</script>

<style lang="less">
  @import "assets/less/variabili.less";
  @import "assets/less/font.less";
  html body {
    font-family: 'Lato-Regular', sans-serif;
  }
  // font di riserva di librerie esterne (Bootstrap e vue2-datepicker usano Helvetica Neue)
  body .tooltip,
  body .popover,
  body .mx-datepicker,
  body .mx-calendar {
    font-family: 'Lato-Regular', sans-serif;
  }
  #app {
  a {
    color: #FFFFFF;
  }
  a:hover
  {
    color:#FFFFFF;
    text-decoration:none;
    cursor:pointer;
  }
  position: relative;
  .cookie{
    .set-font();
    letter-spacing: 1px;
    background-color: @lightBlack;
    .testoCookie{
      color: white;
    }
    .buttoncont{
      width: 100%;
      text-align: center;
      .skew{
        .set-font();
        width: 230px;
        background-color: @myOrange;
        border-color: @borderOrange;
        letter-spacing: 1px;
        .set-font()
      }
    }
  }
}

  @media (max-width: 767px){
    #app {
      .Cookie--base {
        padding-left: 15px;
        padding-right: 15px;
      }
      .cookie{
        .set-font(@size: 12px);
        letter-spacing: 1px;
        .testoCookie{
        }
        .buttoncont{
          .skew{
            .set-font(@size: 12px);
            width: 200px;
            letter-spacing: 1px;
            margin-bottom: 15px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue